import { configureStore } from '@reduxjs/toolkit';
import filterReducer from './reducers/filterSlice';

// Configure the Redux store
export const store = configureStore({
  reducer: {
    filter: filterReducer,
  }
});

export default store;
